var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "authentication-editor" }, [
    _c("label", [_vm._v("Authentication Settings")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "auth-setting-row" },
      [
        _c(
          "a-checkbox",
          {
            attrs: { checked: _vm.data.addSecurityRecommendation },
            on: { change: _vm.updateSecurity },
          },
          [_vm._v("\n            Add security recommendation\n        ")]
        ),
        _vm._v(" "),
        _c("span", { staticClass: "hint-text" }, [
          _vm._v(
            '\n            Adds "For your security, do not share this code" message.\n        '
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "auth-setting-row",
        staticStyle: { "margin-top": "16px" },
      },
      [
        _c("label", [_vm._v("Message TTL (seconds) • Optional")]),
        _vm._v(" "),
        _c("a-input-number", {
          staticStyle: { width: "100%" },
          attrs: {
            value: _vm.data.messageSendTtlSeconds,
            min: 60,
            max: 600,
            placeholder: "60-600",
          },
          on: { change: _vm.updateTtl },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "hint-text" }, [
          _vm._v(
            "\n            Time limit for message delivery (60-600 seconds). Leave empty for default.\n        "
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "auth-setting-row",
        staticStyle: { "margin-top": "16px" },
      },
      [
        _c("label", [_vm._v("Code Expiration (minutes) • Optional")]),
        _vm._v(" "),
        _c("a-input-number", {
          staticStyle: { width: "100%" },
          attrs: {
            value: _vm.data.codeExpirationMinutes,
            min: 1,
            max: 90,
            placeholder: "1-90",
          },
          on: { change: _vm.updateExpiration },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "hint-text" }, [
          _vm._v(
            "\n            How long the OTP code is valid. Shown in footer.\n        "
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _vm.data.otpSubType === "ZERO_TAP"
      ? _c(
          "div",
          {
            staticClass: "auth-setting-row",
            staticStyle: {
              "margin-top": "16px",
              "padding-top": "16px",
              "border-top": "1px solid #e8e8e8",
            },
          },
          [
            _c(
              "a-checkbox",
              {
                attrs: { checked: _vm.data.zeroTapTermsAccepted },
                on: { change: _vm.updateTerms },
              },
              [
                _vm._v(
                  "\n            I accept Zero Tap terms and conditions\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "hint-text" }, [
              _vm._v(
                "\n            Required for Zero Tap autofill to work.\n        "
              ),
            ]),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.data.otpSubType !== "COPY_CODE"
      ? _c(
          "div",
          {
            staticClass: "auth-setting-row",
            staticStyle: { "margin-top": "16px" },
          },
          [
            _c("label", [_vm._v("Supported Android Apps • Optional")]),
            _vm._v(" "),
            _vm._l(_vm.data.supportedApps, function (app, index) {
              return _c(
                "div",
                { key: index, staticClass: "supported-app-row" },
                [
                  _c("a-input", {
                    staticStyle: { flex: "1" },
                    attrs: {
                      value: app.packageName,
                      placeholder: "com.example.app",
                    },
                    on: {
                      input: function ($event) {
                        return _vm.updateAppPackage(index, $event.target.value)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("a-input", {
                    staticStyle: { flex: "1" },
                    attrs: {
                      value: app.signatureHash,
                      placeholder: "Signature hash",
                    },
                    on: {
                      input: function ($event) {
                        return _vm.updateAppSignature(
                          index,
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "link" },
                      on: {
                        click: function ($event) {
                          return _vm.removeApp(index)
                        },
                      },
                    },
                    [_c("a-icon", { attrs: { type: "delete" } })],
                    1
                  ),
                ],
                1
              )
            }),
            _vm._v(" "),
            _c(
              "a-button",
              {
                staticStyle: { "margin-top": "8px" },
                attrs: { size: "small" },
                on: { click: _vm.addApp },
              },
              [
                _c("a-icon", { attrs: { type: "plus" } }),
                _vm._v(" Add app\n        "),
              ],
              1
            ),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }